export default "__VITE_ASSET__CoinQBQM__"